/**
 * This is a shim for the BrowserTracing integration.
 * It is needed in order for the CDN bundles to continue working when users add/remove tracing
 * from it, without changing their config. This is necessary for the loader mechanism.
 */
class BrowserTracingShim  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'BrowserTracing';}

  /**
   * @inheritDoc
   */

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   constructor(_options) {
    this.name = BrowserTracingShim.id;

    // eslint-disable-next-line no-console
    console.error('You are using new BrowserTracing() even though this bundle does not include tracing.');
  }

  /** jsdoc */
   setupOnce() {
    // noop
  }
} BrowserTracingShim.__initStatic();

/** Shim function */
function addTracingExtensions() {
  // noop
}

export { BrowserTracingShim as BrowserTracing, addTracingExtensions };
//# sourceMappingURL=BrowserTracing.js.map
